import {
  changeCheckbox,
  clearSearchCondition,
  getOfficeCount,
  handleSearch,
} from "../../../lib/search/search";

document.addEventListener('DOMContentLoaded', function () {

  // 検索条件を格納（オブジェクトとして初期化）
  let searchCondition = Object.assign({}, window.searchCondition);
  const changeCondition = document.querySelectorAll('.change-cond')

  changeCondition.forEach(function (changeCond) {
    changeCond.addEventListener('click', function () {
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      const resetButton = document.querySelectorAll('.clearForm');
      const searchButtons = document.querySelectorAll('.search-button');

      // チェックボックスの状態が変更されたら発火
      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          changeCheckbox(searchCondition, checkbox);
        });
      });


      // リセットボタン
      resetButton.forEach(function (button) {
        button.addEventListener('click', function () {
          clearSearchCondition(searchCondition, checkboxes);
        });
      });

      searchButtons.forEach(searchButton => {
        searchButton.addEventListener('click', function () {
          handleSearch(searchCondition);
        });
      });

      //チェックボックス初期化
      const initCheckbox = async () => {
        checkboxes.forEach(function (checkbox) {
          if (searchCondition[checkbox.name] && searchCondition[checkbox.name].includes(checkbox.value)) {
            checkbox.checked = true;
          }
        });

        await getOfficeCount(searchCondition);
      }

      initCheckbox();
    });
  });

  /**
   * 連番付きのクエリパラメータを取得する
   *
   * @param {string} name - クエリパラメータの名前
   * @returns {Array[string[]]}
   */
  function getSerialNumberParam(name) {
    const params = new URLSearchParams(location.search);
    const serialNumberParam = [];

    for (let i = 0; ; i++) {
      if (!params.has(name + '[' + i + ']')) {
        break;
      }
      serialNumberParam.push(params.getAll(name + '[' + i + ']'));
    }

    return serialNumberParam;
  }

  /**
   * 検索条件を保持してエリア/路線検索に遷移する
   */
  !(function holdConditionLinkOnClick() {
    // 連番付きのクエリパラメータを取得して、次のクエリパラメータに追加する
    const appendSerialNumberParams = (names, nextQueryParams) => {
      names.forEach((name, i) => {
        getSerialNumberParam(name).forEach((param) => {
          param.forEach((p) => nextQueryParams.append(name + '[]', p));
        });
      });

      return nextQueryParams;
    };

    document.querySelectorAll('[data-hold-condition-link]').forEach((holdConditionLink) => {
      holdConditionLink.addEventListener('click', (event) => {
        event.preventDefault();

        const checkboxes = document.querySelectorAll('[data-search-common-conditions] input[type="checkbox"]');
        const checked = Array.from(checkboxes).filter((checkbox) => checkbox.checked);
        let nextQueryParams = new URLSearchParams();

        // 連番付きのクエリパラメータを取得して、次のクエリパラメータに追加する
        nextQueryParams = appendSerialNumberParams([
          'city_code',
          'address_code',
          'line_station_code'
        ], nextQueryParams);

        // チェックされたチェックボックスの値をクエリパラメータに追加する
        checked.forEach((checkbox) => {
          // checkbox.name がカテゴリ名、checkbox.value が値の場合は commonList[] に追加
          if (checkbox.name === 'service_brand' || checkbox.name === 'capacity_category') {
            nextQueryParams.append('commonList[]', checkbox.value);
            return;
          }

          // checkBox.name が値の場合は common[] に追加
          nextQueryParams.append('common[]', checkbox.name);
        });

        // 検索条件を保持してエリア/路線検索に遷移する
        location.href = holdConditionLink.getAttribute('data-hold-condition-link') + '?' + nextQueryParams.toString();
      });
    });
  })();
});
